import type { ContactConfiguration, Persona } from "@/types/campaign";
import { formatListValues } from "@/utils/sidebar";

export function formatPersonaLabel(persona: Persona): string {
  const parts = [
    persona.levels.length > 0 ? persona.levels.join(", ") : "Alle roller",
    persona.groups.length > 0 ? persona.groups.join(", ") : "Alle afdelinger",
    persona.titles.length > 0
      ? persona.titles.map((t) => t.title).join(", ")
      : null,
  ].filter(Boolean);

  return parts.join(" - ") + (persona.requirePhone ? " m. telefonnummer" : "");
}

export function formatContactsSidebarLabel(
  config: ContactConfiguration,
): string {
  if (!config?.personas?.length) {
    return "";
  }

  const formattedContacts = config.personas.map(formatPersonaLabel);
  return formatListValues(formattedContacts);
}
